<ng-container *ngIf="person?.id || company?.id">
    <ng-container *ngIf="company?.id">
        <bcm-company-link [company]="company" [disableLink]="disableLink"></bcm-company-link>
    </ng-container>
    <ng-container *ngIf="person?.id">
        <bcm-person-link [person]="person" [disableLink]="disableLink"></bcm-person-link>
    </ng-container>
</ng-container>
